'use client';

import { storyblokEditable } from 'gatsby-source-storyblok';
import React from 'react';
import { Link } from 'gatsby';
import { getLink } from '../../utils/link';
import { useTranslation } from 'react-i18next';

/**
 * Renders a breadcrumb component that displays a navigation path.
 *
 * @component
 * @param {Object} blok - The Storyblok object.
 * @returns {JSX.Element} The breadcrumb component.
 */

// This component is used outside of Storyblok context, and is not editable in Storyblok.
const Breadcrumbs = ({ blok, breadcrumbs }) => {
  const { t } = useTranslation(['header']);
  return (
    <div
      className="text-xs col-span-12 px-4 md:px-8 text-black-50 mt-4 md:mt-8"
      {...storyblokEditable(blok)}
    >
      <ul>
        <li key={blok._uid} className="inline-block">
          <Link className="no-underline hover:text-black" to="/">
            <span className="whitespace-pre">{t('Start')}</span>
          </Link>
        </li>
        {breadcrumbs.length > 0 &&
          breadcrumbs.map((breadcrumb) => {
            return (
              <li key={breadcrumb.full_slug} className="inline-block">
                <Link
                  className="no-underline hover:text-black"
                  to={getLink(breadcrumb.full_slug)}
                >
                  <span className="whitespace-pre">
                    {' / '}
                    {breadcrumb.name}
                  </span>
                </Link>
              </li>
            );
          })}
      </ul>
    </div>
  );
};

export default Breadcrumbs;
